/* eslint-disable array-callback-return */
import React ,{useState, useMemo, useRef}from 'react';
import swal from "sweetalert";
import $ from 'jquery' 
import load from '../../img/load.gif';
import { useWallet } from '../WalletProvider';
import { saveRefUser } from "../helpers/helper"
import {verifyTronTransaction} from "./airdropHelper"

function ContainerStepThree(props) {

    const {validData,totalTokens, tokenContractAddress,tokendecimal,isToken,deflationary,erc1155} = props
    const { currencyDetails,account } = useWallet();
    const [Tx, setTx] = useState({
        totalTx : 0,
        currentTx : 0
    });
    const [confirmTx, setConfirmTx] = useState(0)
    const [sendDrop, setSendDrop] = useState(false);
    const [txHash, setTxHash] = useState([]);
    const queryParams = useMemo(()=>new URLSearchParams(window.location.search),[])
    const currency = useRef(queryParams.get("currency"));

    function devideArr(arr,n) {
        return new Promise((resolve, reject) => {
            
            const splittedArray = [];
             while (arr.length > 0) {
               splittedArray.push(arr.splice(0,n));  
             }
             resolve(splittedArray);
        })
   }
   //Tron Functions
        async function tronAirDrop(){
            return new Promise(async(resolve, reject)=>{
                const tronConnect = await window.tronWeb.contract().at(currencyDetails.airdropAddress);
                let addArr = [];
                let amountArr = [];
                validData.map((item)=>{
                    addArr.push(item.address);
                    if(isToken){
                        amountArr.push(`${item.amount*10**Number(tokendecimal)}`);
                    }else{
                        amountArr.push(`${item.amount}`);
                    }
                    
                })
                // let approvedBal = await token_contract.methods.allowance(window.ethereum.selectedAddress, contract_address).call();
                if(addArr.length > 0 && amountArr.length > 0 && amountArr.length===addArr.length){
                    
                    // if(parseFloat(approvedBal)>parseFloat(totalAmt)){
                        let arrOfAddArr = await devideArr(addArr,500);
                        let arrOfamountArr = await devideArr(amountArr,500);
                        setTx(
                            lastTx => {
                                return { 
                                ...lastTx,
                                    totalTx: arrOfAddArr.length,
                                    currentTx: 0 
                                }
                            }
                        );
                        console.log("before transaction")
                        // for(let i=0; i < arrOfAddArr.length; i++){
                         await Promise.all(arrOfAddArr.map(async(item,i)=>{
                            setTx(
                                lastTx => {
                                    return { 
                                    ...lastTx,
                                        currentTx: i+1 
                                    }
                                }
                            );

                            // eslint-disable-next-line no-loop-func
                            let serviceFee = await tronConnect.dropUnitPrice().call();
                            serviceFee = Number(serviceFee)*arrOfAddArr[i].length;

                            let total =  arrOfamountArr[i].reduce((a, b) => Number(a) + Number(b), 0)
                            let txhash;
                            await tronConnect.erc20Airdrop(`${tokenContractAddress}`,arrOfAddArr[i], arrOfamountArr[i],`${total}`,deflationary).send({ from: account,value: serviceFee}, function (err, result) {
                                
                                if (err) {
                                    resolve(swal("Transaction Error", { buttons: false, icon: "error", timer: 2000 }));
                                }
                                if (result) {
                                    txhash = result;
                                    setSendDrop(true);
                                   swal("Your transaction is sent, Please wait for confirmation.", { buttons: false, icon: "success", timer: 2000 });
                                   setTimeout(() => { $('#load-img').css("display", "block"); }, 2000);
                                }
                            // eslint-disable-next-line no-loop-func
                            }).then(()=>{
                                // setTimeout(() => {
                                    verifyTronTransaction(txhash).then((isVerified)=>{
                                        if(isVerified){
                                            setConfirmTx(i+1)
                                            setTxHash(oldArray => [...oldArray, txhash])
                                            $('#hash-show').css("display", "block");
                                            if(i === arrOfAddArr.length -1 ){
                                                $('#load-img').css("display", "none");
                                            }
                                            resolve(swal("Transaction successful",{ buttons: false, icon: "success", timer: 2000 }));
                                        }else{
                                            if(i === arrOfAddArr.length -1 ){
                                                $('#load-img').css("display", "none");
                                            }
                                            swal("Transaction Error", { buttons: false, icon: "error", timer: 2000 })
                                        }
                                    })
                                // }, 5000);
                            })
                        }))
                        
                        


                }else{
                    resolve(swal("There is some error while reading your file", {button:false, icon:"warning", timer:1000}));
                }
            })   
        }
        async function tronAirdropNFT(){
            return new Promise(async(resolve, reject)=>{
                const tronConnect = await window.tronWeb.contract().at(currencyDetails.airdropAddress);
                let addArr = [];
                let NFTArr = [];
                let countArr = [];
                let type = erc1155 ? 1 : 0 ;
                validData.map((item)=>{
                    addArr.push(item.address);
                    if(!erc1155){
                        NFTArr.push(`${item.id}`);
                        countArr.push(0); 
                    }else{
                        NFTArr.push(`${item.id}`);
                        countArr.push(`${item.id}`); 
                    }
                })

                // let approvedBal = await token_contract.methods.allowance(window.ethereum.selectedAddress, contract_address).call();
                if(addArr.length > 0 && NFTArr.length > 0 && NFTArr.length===addArr.length){
                    
                    // if(parseFloat(approvedBal)>parseFloat(totalAmt)){
                        let arrOfAddArr = await devideArr(addArr,500);
                        let arrOfNFTArr = await devideArr(NFTArr,500);
                        let arrOfCountArr = await devideArr(countArr,500);

                        setTx(
                            lastTx => {
                                return { 
                                ...lastTx,
                                    totalTx: arrOfAddArr.length,
                                    currentTx: 0 
                                }
                            }
                        );
                        
                        // for(let i=0; i < arrOfAddArr.length; i++){
                        await Promise.all(arrOfAddArr.map(async(item,i)=>{
                            setTx(
                                lastTx => {
                                    return { 
                                    ...lastTx,
                                        currentTx: i+1 
                                    }
                                }
                            );
                            // eslint-disable-next-line no-loop-func
                            let serviceFee = await tronConnect.dropUnitPrice().call();
                            serviceFee = Number(serviceFee)*arrOfAddArr[i].length;
                            let txhash;
                            await tronConnect.NFTAirdrop(`${tokenContractAddress}`,arrOfAddArr[i], arrOfNFTArr[i], arrOfCountArr[i],type).send({ from: account,value: serviceFee}, function (err, result) {
                                
                                if (err) {
                                    resolve(swal("Transaction Error", { buttons: false, icon: "error", timer: 2000 }));
                                }
                                if (result) {
                                    setSendDrop(true);
                                    swal("Your transaction is sent, Please wait for confirmation.", { buttons: false, icon: "success", timer: 2000 });
                                    setTimeout(() => { $('#load-img').css("display", "block"); }, 2000);
                                }
                            // eslint-disable-next-line no-loop-func
                            }).then(()=>{
                                setTimeout(() => {
                                    verifyTronTransaction(txhash).then((isVerified)=>{
                                        if(isVerified){
                                            setConfirmTx(i+1)
                                            setTxHash(oldArray => [...oldArray, txhash])
                                            $('#hash-show').css("display", "block");
                                            if(i === arrOfAddArr.length -1 ){
                                                $('#load-img').css("display", "none");
                                            }
                                            resolve(swal("Transaction successful", { buttons: false, icon: "success", timer: 2000 }));
                                        }else{
                                            resolve(swal("Transaction Error", { buttons: false, icon: "error", timer: 2000 }));
                                        }
                                    })
                                }, 5000);
                            })
                        }))
                        $('#load-img').css("display", "none");

                        

                }else{
                    resolve(swal("There is some error while reading your file", {button:false, icon:"warning", timer:1000}));
                    }
            })  
        }

        async function tronAirdropWithReferrer(e, next){
            e.preventDefault()
            const queryParams = new URLSearchParams(window.location.search)
            var referrer = queryParams.get("referrer");
            if(referrer === null || referrer === undefined || referrer === ''){
                referrer = "0x"
            }
            const saveReferrer = await saveRefUser(account, referrer);
            if(JSON.stringify(saveReferrer.success) === "true" || JSON.stringify(saveReferrer.success) === true){
                await next();
            }else{
                swal(JSON.stringify(saveReferrer.msg), { buttons: false, icon: "error", timer: 2000 })
            }
        }
        async function tronAirdropNFTWithreferrer(e, next){
            e.preventDefault()
            const queryParams = new URLSearchParams(window.location.search)
            var referrer = queryParams.get("referrer");
            if(referrer === null || referrer === undefined || referrer === ''){
                referrer = "0x"
            }
            const saveReferrer = await saveRefUser(account, referrer);
            if(JSON.stringify(saveReferrer.success) === "true" || JSON.stringify(saveReferrer.success) === true){
                await next();
            }else{
                swal(JSON.stringify(saveReferrer.msg), { buttons: false, icon: "error", timer: 2000 })
            }
        }

   //Other Than Tron
   async function airdrop(){
        return new Promise(async(resolve, reject)=>{
            let addArr = [];
            let amountArr = [];
            validData.map((item)=>{
                addArr.push(item.address);
                if(isToken){
                    amountArr.push(`${item.amount*10**Number(tokendecimal)}`);
                }else{
                    amountArr.push(`${item.amount}`);
                }
                
            })
            // let approvedBal = await token_contract.methods.allowance(window.ethereum.selectedAddress, contract_address).call();
            if(addArr.length > 0 && amountArr.length > 0 && amountArr.length===addArr.length){
                
                // if(parseFloat(approvedBal)>parseFloat(totalAmt)){
                    let arrOfAddArr = await devideArr(addArr,500);
                    let arrOfamountArr = await devideArr(amountArr,500);
                    setTx(
                        lastTx => {
                            return { 
                            ...lastTx,
                                totalTx: arrOfAddArr.length,
                                currentTx: 0 
                            }
                        }
                    );
                    
                    // for(let i=0; i < arrOfAddArr.length; i++){
                    await Promise.all(arrOfAddArr.map(async(item,i)=>{
                        setTx(
                            lastTx => {
                                return { 
                                ...lastTx,
                                    currentTx: i+1 
                                }
                            }
                        );

                        // eslint-disable-next-line no-loop-func
                        let serviceFee = await currencyDetails.airDropContract.methods.dropUnitPrice().call();
                        serviceFee = Number(serviceFee)*arrOfAddArr[i].length;

                        let total =  arrOfamountArr[i].reduce((a, b) => Number(a) + Number(b), 0)
                        await currencyDetails.airDropContract.methods.erc20Airdrop(`${tokenContractAddress}`,arrOfAddArr[i], arrOfamountArr[i],`${total}`,deflationary).send({ from: account,value: serviceFee}, function (err, result) {
                            
                            if (err) {
                                resolve(swal("Transaction Error", { buttons: false, icon: "error", timer: 2000 }));
                            }
                            if (result) {
                                setSendDrop(true)
                                swal("Your transaction is sent, Please wait for confirmation.", { buttons: false, icon: "success", timer: 2000 });
                                setTimeout(() => { $('#load-img').css("display", "block"); }, 2000);
                            }
                        // eslint-disable-next-line no-loop-func
                        }).on('receipt', function (receipt) {
                            if (receipt.status === true) {
                                setConfirmTx(i+1)
                                setTxHash(oldArray => [...oldArray, receipt.transactionHash])
                                $('#hash-show').css("display", "block");
                                resolve(swal("Transaction successful", { buttons: false, icon: "success", timer: 2000 }));
                            } else {
                                resolve(swal("Transaction Error", { buttons: false, icon: "error", timer: 2000 }));
                            }
                        })
                    }))
                    $('#load-img').css("display", "none");

            }else{
                resolve(swal("There is some error while reading your file", {button:false, icon:"warning", timer:1000}));
            }
        })   
   }
   async function airdropNFT(){
        return new Promise(async(resolve, reject)=>{
            let addArr = [];
            let NFTArr = [];
            let countArr = [];
            let type = erc1155 ? 1 : 0 ;
            validData.map((item)=>{
                addArr.push(item.address);
                if(!erc1155){
                    NFTArr.push(`${item.id}`);
                    countArr.push(0); 
                }else{
                    NFTArr.push(`${item.id}`);
                    countArr.push(`${item.id}`); 
                }
            })

            // let approvedBal = await token_contract.methods.allowance(window.ethereum.selectedAddress, contract_address).call();
            if(addArr.length > 0 && NFTArr.length > 0 && NFTArr.length===addArr.length){
                
                // if(parseFloat(approvedBal)>parseFloat(totalAmt)){
                    let arrOfAddArr = await devideArr(addArr,500);
                    let arrOfNFTArr = await devideArr(NFTArr,500);
                    let arrOfCountArr = await devideArr(countArr,500);

                    setTx(
                        lastTx => {
                            return { 
                            ...lastTx,
                                totalTx: arrOfAddArr.length,
                                currentTx: 0 
                            }
                        }
                    );
                    
                    // for(let i=0; i < arrOfAddArr.length; i++){
                    await Promise.all(arrOfAddArr.map(async(item,i)=>{
                        setTx(
                            lastTx => {
                                return { 
                                ...lastTx,
                                    currentTx: i+1 
                                }
                            }
                        );
                        // eslint-disable-next-line no-loop-func
                        let serviceFee = await currencyDetails.airDropContract.methods.dropUnitPrice().call();
                        serviceFee = Number(serviceFee)*arrOfAddArr[i].length;
                        await currencyDetails.airDropContract.methods.NFTAirdrop(`${tokenContractAddress}`,arrOfAddArr[i], arrOfNFTArr[i], arrOfCountArr[i],type).send({ from: account,value: serviceFee}, function (err, result) {
                            
                            if (err) {
                                resolve(swal("Transaction Error", { buttons: false, icon: "error", timer: 2000 }));
                            }
                            if (result) {
                                setSendDrop(true)
                                swal("Your transaction is sent, Please wait for confirmation.",{ buttons: false, icon: "success", timer: 2000 });
                                setTimeout(() => { $('#load-img').css("display", "block"); }, 2000);
                            }
                        // eslint-disable-next-line no-loop-func
                        }).on('receipt', function (receipt) {
                            if (receipt.status === true) {
                                setConfirmTx(i+1)
                                setTxHash(oldArray => [...oldArray, receipt.transactionHash])
                                $('#hash-show').css("display", "block");
                                resolve(swal("Transaction successful", { buttons: false, icon: "success", timer: 2000 }));
                            } else {
                                resolve(swal("Transaction Error", { buttons: false, icon: "error", timer: 1000 }));
                            }
                        })
                    }))
                    $('#load-img').css("display", "none");

            }else{
                resolve(swal("There is some error while reading your file", {button:false, icon:"warning", timer:1000}));
            }
        })  
    }

   async function airdropWithReferrer(e, next){
        e.preventDefault();
        const queryParams = new URLSearchParams(window.location.search)
        var referrer = queryParams.get("referrer");
        if(referrer === null || referrer === undefined || referrer === ''){
            referrer = "0x"
        }
        const saveReferrer = await saveRefUser(account, referrer);
        if(JSON.stringify(saveReferrer.success) === "true" || JSON.stringify(saveReferrer.success) === true){
            await next();
        }else{
            swal(JSON.stringify(saveReferrer.msg), { buttons: false, icon: "error", timer: 2000 })
        }
    }
    async function airdropNFTWithreferrer(e, next){
        e.preventDefault();
        const queryParams = new URLSearchParams(window.location.search)
        var referrer = queryParams.get("referrer");
        if(referrer === null || referrer === undefined || referrer === ''){
            referrer = "0x"
        }
        const saveReferrer = await saveRefUser(account, referrer);
        if(JSON.stringify(saveReferrer.success) === "true" || JSON.stringify(saveReferrer.success) === true){
            await next();
        }else{
            swal(JSON.stringify(saveReferrer.msg), { buttons: false, icon: "error", timer: 2000 })
        }
    }
    

  return (
    <div className="tab-pane" id="step3">
        {!sendDrop && <div className="tb2">
            <div className="dg-er mt-5">
                <div className='tb12a'>
                <table className="price-comparison-table mb-3" style={{border:"1px solid #fff",    width: "100%"}}>
                    <tbody>
                        <tr>
                    
                            <th>Single Transfer Fee</th>
                            <th>Rate</th>
                        </tr>
                        <tr>
                        
                            <td>0.00006* ETH <span>
                                </span>
                            </td>
                            <td>15,000 TXs per 1 ETH</td>
                        </tr>
                        <tr>
                            
                            <td>0.000286 BNB <span>
                                </span>
                            </td>
                            <td>3,500 TXs per 1 BNB</td>
                        </tr>
                        <tr>
                            
                            <td>0.00166* AVAX</td>
                            <td>600 TXs per 1 AVAX</td>
                        </tr>
                        <tr>
                        
                            <td>0.1 MATIC <span>
                                </span>
                            </td>
                            <td>10 TXs per 1 MATIC</td>
                        </tr>
                        <tr>
                            
                            <td>0.1 TRX <span>
                                </span>
                            </td>
                            <td>10 TXs per 1 TRX</td>
                        </tr>
                    </tbody>
                </table>
                </div>
                

                <div className="row">
                    <div className="col-md-12">
                        <div className="sh-vv">
                            <h4>{totalTokens}</h4>
                            <p>Total number of tokens to send</p>
                            {isToken ? 
                                (currency.current === 'trx' ? <button className="aredropbtn" type="button" onClick = {(e)=>{
                                   tronAirdropWithReferrer(e, tronAirDrop)
                                }}>Send Airdrop</button> : <button className="aredropbtn" type="button" onClick = {(e)=>{
                                    airdropWithReferrer(e, airdrop)
                                }}>Send Airdrop</button>) :
                                (
                                    currency.current === 'trx' ? <button className="aredropbtn" type="button" onClick = {(e) => tronAirdropNFTWithreferrer(e, tronAirdropNFT)}>Send Airdrop</button> :
                                    <button className="aredropbtn" type="button" onClick = {(e) => airdropNFTWithreferrer(e, airdropNFT)}>Send Airdrop</button> 
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>}
        {sendDrop && <div className="" id="proceedhash">
            <div className="tb2 my-5">
                <div className="dg-er">
                    <div className="row">
                        <div className="col-md-12" id="load-img">
                            <div className="sh-vv">
                                <img  src={load} alt = "" className="img-responsive" style={{ width: "90px" }} />
                                {/* <h4 id="rightmark" style="    width: 100px;    display: flex;    height: 100px;    border: 3px solid #ffffff91;    justify-content: center;    border-radius: 50%;    margin: 0 auto 10px;    align-items: center;color: #16d716;    font-size: 50px;"></h4> */}
                                <p id="proceedText">Proceeding transaction {Tx.currentTx} of {Tx.totalTx}</p>
                            </div>
                        </div>
                        <div id="hash-show" style={{display:"none", padding: "0px 15px",textAlign: "center",width: "100%"}}>
                            <div className="sh-vv">
                                <h4 id="rightmark" style={{width:"100px",display:"flex",height:"100px",border:"3px solid #ffffff91",justifyContent:"center",borderRadius:"50%",margin:"0 auto 10px",alignItems:"center",color:"#16d716",fontSize:"50px"}}>✓</h4>
                                <p>Congratulations! You have successfully finished your multidrop. {confirmTx} of {Tx.totalTx}</p>
                            </div>
                            <div className="col-md-12">
                                <div className="">
                                    <h4>Multidrop Transactions</h4>
                                    {txHash.map((item,i)=>{
                                        return <a key = {i} target = "_blank" style={{display: "inline-block"}} href={`https://${currencyDetails.blockexplorer}/tx/`+item} rel="noreferrer">{item.substr(0, 5)}....{item.substr(-5)}</a>
                                    })}
                                    
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>}
    </div>
  )
}

export default ContainerStepThree